import * as React from "react";
import Modal from "react-bootstrap/Modal";
import { SS_SupportSystemSheet } from "../models/SS_SupportSystemSheet";
import { SilModal } from "./SilModal";
import { Config, isRequired, validateValueIsInRange, isNumber, ValueDesc, generateInputFields, getFirstError, generateDeviceRow, getDefault } from "../formHelpers";

interface Props {
  closeModal: () => void;
  shownModal: string;
  supportSheet: SS_SupportSystemSheet;
  saveCustomSupportSystem: (ss_supportSystemSheet: SS_SupportSystemSheet, file: File) => void;
}

interface State {
  closeFocus: boolean;
  supportSheet?: Partial<SS_SupportSystemSheet>;
}

const supportConfig: Config<SS_SupportSystemSheet> = {
  source: {
    valueName: 'source',
    display: 'Data Source',
    inputProps: { maxLength: 10 },
    validators: [isRequired]
  },
  supportSystemID: {
    valueName: 'supportSystemID',
    display: 'Support System Id',
    inputProps: { maxLength: 10 },
    validators: [isRequired]
  },
  supportSystemType: {
    valueName: 'supportSystemType',
    display: 'Support System Type',
    validators: [isRequired]
  },
  supportSystemDescription: {
    valueName: 'supportSystemDescription',
    display: 'Support System Description',
  },
  pfdAverage: {
    valueName: 'pfdAverage',
    display: 'PFDavg',
    inputProps: { maxLength: 15 },
    validators: [isRequired, isNumber]
  },
  stR1Year: {
    valueName: 'stR1Year',
    display: 'STR (1/Yr)',
    inputProps: { maxLength: 15 },
    validators: [isRequired, isNumber]
  },
  hft: {
    valueName: 'hft',
    display: 'HFT',
    type: {
      type: 'select',
      options: [0, 1, 2]
    },
    defaultValue: 0
  },
  snts: {
    valueName: 'snts',
    display: 'Notes',
  }
};

export class CustomerSupportModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      closeFocus: false,
      supportSheet: getDefault(supportConfig)
    }
  }

  private fileRef = React.createRef<HTMLInputElement>();

  inputStyle: React.CSSProperties = {
    backgroundColor: "white"
  }

  handleClick = () => {

    const supportSystemSheet = this.state.supportSheet;

    const file = this.fileRef.current.files[0];

    this.props.saveCustomSupportSystem(supportSystemSheet as any, file);
    this.props.closeModal();
  }

  generateRow = (desc: ValueDesc<SS_SupportSystemSheet>) => {
    const supportSheet = this.props.supportSheet ? this.props.supportSheet : this.state.supportSheet;
    return generateDeviceRow(
      desc,
      supportSheet,
      (st) => this.setState({ supportSheet: st }),
      this.props.supportSheet != null);
  }

  render() {
    const supportSheet = this.props.supportSheet || this.state.supportSheet;

    var firstError = getFirstError<SS_SupportSystemSheet>(supportSheet, supportConfig);

    return (
      <SilModal title="Customer Support" closeModal={this.props.closeModal}>
        <div id="supportpopup" style={{ width: 'auto', minHeight: '98.8667px', display: 'block', height: 'auto' }} className="ui-dialog-content ui-widget-content">
          <table>
            <tbody>
              {this.generateRow(supportConfig.source)}
              {this.generateRow(supportConfig.supportSystemID)}
              {this.generateRow(supportConfig.supportSystemType)}
              {this.generateRow(supportConfig.supportSystemDescription)}
              {this.generateRow(supportConfig.pfdAverage)}
              {this.generateRow(supportConfig.stR1Year)}
              {this.generateRow(supportConfig.hft)}
              <tr>
                <td className="custom-support-label">
                  <span id="Label55">Note </span>
                </td>
                <td className="custom_device_text">
                  <textarea rows={2} cols={20}
                    disabled={this.props.supportSheet == null ? false : true}
                    style={{
                      backgroundColor: "white",
                      height: "100px"
                    }}
                    {...generateInputFields(supportSheet, supportConfig.snts, (obj) => this.setState({ supportSheet: obj }))} />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="form-group">
            <label htmlFor="supportsystemfileimage">Select Alternate User Image File (optional):</label>
            <input type="file" multiple={true} name="SupportFileUpload" id="SupportFileUpload" ref={this.fileRef} />
            <p className="help-block">Select the image file to represent this custom support system.</p>
          </div>
          {firstError != null ? <div className="custom-errors"><label>{firstError}</label></div> : ''}
          {this.props.supportSheet == null ?
            <div style={{ textAlign: "center" }}>
              <input
                type="submit"
                name="Btn_support_save"
                defaultValue="Save"
                id="Btn_support_save"
                disabled={firstError != null}
                className={'edit-button ' + (firstError != null ? 'disabled green-button' : 'green-button')}
                onClick={this.handleClick} />
            </div>
            :
            null
          }
        </div>
      </SilModal>
    );
  }
}